import { render } from "./MenuMain.vue?vue&type=template&id=7315059a&scoped=true"
import script from "./MenuMain.vue?vue&type=script&lang=js"
export * from "./MenuMain.vue?vue&type=script&lang=js"

import "./MenuMain.vue?vue&type=style&index=0&id=7315059a&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7315059a"]])

export default __exports__